import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import pluralize from 'pluralize';

import {
  filter, each, indexOf, without, concat, uniq, delay, reduce, truncate, find, map, intersection, first,
} from 'lodash';
import Fa from 'react-fontawesome';
import { Dropdown, MenuItem, OverlayTrigger, Tooltip } from 'react-bootstrap';

import { getForecastCategoryFilter } from '../../../../components/search-form/search-form-reducer';

export function getAllPeriods() {
  return [
    { label: 'Weekly', value: 'week', labelAlt: 'weekly' },
    { label: 'Monthly', value: 'month', labelAlt: 'monthly' },
    { label: '60 Day', value: '60-day', labelAlt: '60 day' },
    { label: '90 Day', value: '90-day', labelAlt: '90 day' },
  ];
}

class ForecastForm extends Component {
  constructor(props) {
    super(props);
    const { defaultForecastCategoryParams } = props;
    let defaultCategories = [];

    if (defaultForecastCategoryParams) {
      defaultCategories = defaultForecastCategoryParams.mappings || [];
    }
    this.state = {
      categories: defaultCategories,
      oldCategories: [],
      categoryOpen: false,
      period: props.defaultForecastPeriod || 'month',
    };
    this.setCategories = this.setCategories.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
  }

  componentWillMount() {
    const { userPreferenceKey, userPreferencePeriodKey, rememberControlStates } = this.props;
    if (rememberControlStates) {
      const { userPreferences } = this.context;
      if (userPreferenceKey) {
        const categories = userPreferences[userPreferenceKey] || [];
        this.setState({ categories });
      }
      if (userPreferencePeriodKey) {
        const period = userPreferences[userPreferencePeriodKey] || 'month';
        this.setState({ period });
      }
    }
  }

  componentDidMount() {
    this.checkProps(this.props);
    delay(() => {
      this.submit();
    }, 500);
  }

  componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }

  setPeriod(period) {
    this.setState({ period });
    if (this.props.userPreferencePeriodKey && this.props.rememberControlStates) {
      this.context.updateUserPreference(this.props.userPreferencePeriodKey, period);
    }
    delay(() => {
      this.submit();
    }, 100);
  }

  setCategories(category) {
    const { categories } = this.state;
    let newCategories = [...categories];
    if (indexOf(newCategories, category) >= 0) {
      newCategories = without(newCategories, category);
    } else {
      newCategories = concat(newCategories, category);
    }
    const cats = uniq(newCategories);
    this.setState({ categories: cats });
    if (this.props.userPreferenceKey && this.props.rememberControlStates) {
      this.context.updateUserPreference(this.props.userPreferenceKey, cats);
    }
  }

  submit() {
    const { forecastCategoryFilter } = this.props;
    if (forecastCategoryFilter) {
      const { mappings } = forecastCategoryFilter;
      const availableMappingIds = map(mappings, '_id');
      const requestedMappingIds = intersection(this.state.categories, availableMappingIds);
      const mappingLabels = map(filter(mappings, m => indexOf(requestedMappingIds, m._id) >= 0), 'label');
      const selectedPeriod = find(getAllPeriods(), { value: this.state.period });
      const params = {
        _id: forecastCategoryFilter._id,
        type: 'include',
        values: [],
        mappings: requestedMappingIds,
      };
      this.props.onParamChange(this.state.period, params, selectedPeriod ? selectedPeriod.labelAlt : this.state.period, mappingLabels);
    }
  }

  checkProps(props) {
    const { categories } = this.state;
    const { forecastCategoryFilter } = props;
    this.setState({ categories });
    if (categories.length === 0) {
      const commitOption = find(forecastCategoryFilter ? forecastCategoryFilter.mappings : [], { label: 'Commit' });
      if (commitOption) {
        this.setCategories(commitOption._id);
      } else {
        const firstOptions = first(forecastCategoryFilter ? forecastCategoryFilter.mappings : []);
        if (firstOptions) {
          this.setCategories(firstOptions._id);
        }
      }
    }
  }

  render() {
    const { period, categoryOpen, categories } = this.state;
    const { disabled, forecastCategoryFilter, forecastClosedMonths } = this.props;

    if (!(forecastClosedMonths > 0 && forecastCategoryFilter && forecastCategoryFilter.mappings.length > 0)) {
      return null;
    }

    const options = reduce(forecastCategoryFilter ? forecastCategoryFilter.mappings : [], (items, mapping) => {
      items.push({
        ...mapping,
        active: indexOf(categories, mapping._id) >= 0,
      });
      return items;
    }, []);
    const commitOption = find(options, { label: 'Commit' }) || first(options);

    const activeLabels = [];
    each(options, (category) => {
      if (category.active) {
        activeLabels.push(category.label);
      }
    });

    let activeLabelString = commitOption ? commitOption.label : 'Commit';
    if (activeLabels.length > 0) {
      activeLabelString = activeLabels.join(' + ');
    }
    const activeLabelStringShort = truncate(activeLabelString, { length: 20 });
    const tip = (
      <Tooltip id="forecast-dropdown-tip">
        {activeLabelString}
      </Tooltip>
    );

    const allPeriods = getAllPeriods();
    const activePeriod = find(allPeriods, { value: period }) || first(allPeriods);

    return (
      <div style={{ paddingTop: '0.5em' }}>
        <Dropdown
          id="perf-period-dropdown"
          disabled={disabled}
        >
          <Dropdown.Toggle bsSize="small" disabled={disabled}>
            {activePeriod.label}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {allPeriods.map(s => (
              <MenuItem
                key={s.value}
                active={activePeriod.value === s.value}
                onSelect={() => { this.setPeriod(s.value); }}
              >
                {s !== null ? s.label : 'Monthly'}
              </MenuItem>
              ))}
          </Dropdown.Menu>
        </Dropdown>
        &nbsp;
        <OverlayTrigger trigger={['hover', 'focus']} placement="top" overlay={tip}>
          <Dropdown
            id="dist-category-dropdown"
            open={categoryOpen}
            disabled={disabled}
            onToggle={(open, e, s) => {
              if (!categoryOpen) {
                this.setState({ oldCategories: [...this.state.categories], categoryOpen: true });
              } else if (categoryOpen && s.source === 'rootClose') {
                this.setState({ categoryOpen: false });
                if (this.state.categories.length === 0) {
                  if (commitOption) {
                    this.setCategories(commitOption._id);
                  }
                }
                delay(() => {
                  const remain1 = filter(this.state.categories, c => indexOf(this.state.oldCategories, c) < 0);
                  const remain2 = filter(this.state.oldCategories, c => indexOf(this.state.categories, c) < 0);
                  if (remain1.length > 0 || remain2.length > 0) {
                    this.submit();
                  }
                }, 100);
              }
            }}
          >
            <Dropdown.Toggle bsSize="small" disabled={disabled}>
              {activeLabelStringShort}
            </Dropdown.Toggle>
            {options.length > 0 &&
              <Dropdown.Menu>
                {options.map(s => (
                  <MenuItem
                    key={s._id}
                    active={s.active}
                    onSelect={() => { this.setCategories(s._id); }}
                  >
                    <Fa name={s.active ? 'check-square-o' : 'square-o'} /> {s.label}
                  </MenuItem>
                  ))}
              </Dropdown.Menu>
            }
          </Dropdown>
        </OverlayTrigger>
        &nbsp;forecast accuracy for the past {forecastClosedMonths} {pluralize('month', forecastClosedMonths)}.
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  const forecastCategoryFilter = getForecastCategoryFilter(state);
  return {
    forecastCategoryFilter: {
      ...forecastCategoryFilter,
      mappings: filter(forecastCategoryFilter ? forecastCategoryFilter.mappings : [], mapping => (mapping.label !== 'Closed' &&
        mapping.label !== 'Omitted' &&
        mapping.values &&
        mapping.values.length > 0)),
    },
  };
}


ForecastForm.propTypes = {
  forecastCategoryFilter: PropTypes.shape({
    mappings: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string.isRequired,
    })),
  }),
  forecastClosedMonths: PropTypes.number.isRequired,
  userPreferenceKey: PropTypes.string,
  userPreferencePeriodKey: PropTypes.string,
  onParamChange: PropTypes.func,
  disabled: PropTypes.bool,
  defaultForecastPeriod: PropTypes.string,
  defaultForecastCategoryParams: PropTypes.shape({}),
  rememberControlStates: PropTypes.bool,
};
ForecastForm.defaultProps = {
  onParamChange: () => {},
  disabled: false,
  forecastCategoryFilter: null,
  userPreferenceKey: null,
  userPreferencePeriodKey: null,
  defaultForecastPeriod: 'monthly',
  defaultForecastCategoryParams: null,
  rememberControlStates: false,
};
ForecastForm.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  userPreferences: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(ForecastForm);
